export const TABLE_FILTER_SETTINGS_KEY = 'tableFilterSettings';
export const TABLE_FILTER_DATE_RANGE_FIELDS = {
  startDate: 'startDate',
  endDate: 'endDate',
};
export const TABLE_FILTER_DATE_FIELDS = {
  dateField: 'date',
  format: 'YYYY-MM-DDT00:00:00',
};
